import * as firebase from 'firebase/app'
import _ from 'lodash'
import ah from '../utils/ajaxhook'
import urlParse from 'url-parse'
import {tryCall, safeComputeInteger} from "../utils";
import runtime from "../utils/runtime";
import { transport } from '../transport';
import { checkCompat } from '../compatibility';
import { FIREBASE_ENDPOINT_NAME, PROMETHEUS_ENDPOINT_NAME } from '../constants';
import { getUrl } from '../utils/path';

//标记数组当前位置
let markPerformanceNavigationIndex = 0
//是否初始化标记
let isInitFlag = true

// 管理 firebase 统计渠道的网络性能
export function init() {
    //页面进来通过performance获取已请求过的接口数据
    tryCall(() => reportResourceNavigation(), false)
    // performance后，通过xhr代理获取后续的接口数据
    tryCall(() => hookXHR(), false)
}

function reportResourceNavigation() {
    const apiEntry = getPerformanceNavigationList()
    apiEntry.forEach(parseEntryAndReport)

    // 标记统计成功
    return true
}

function hookXHR() {
    isInitFlag = false

    //FIXME fetch没测
    ah.hookAjax({
        //触发的回调是onload/onreadystatechange其中一种
        onload: function () {
            reportResourceNavigation()
        },
        //拦截回调
        onreadystatechange: function (xhr) {
            if(xhr.readyState === 4) {
                reportResourceNavigation();
            }
        },
    })
    return true
}

function is304(entry) {
    if (
        entry.encodedBodySize > 0 &&
        entry.tranferSize > 0 &&
        entry.tranferSize < entry.encodedBodySize
    ) {
        return true;
    }

    return false;
}

function parseEntryAndReport(timingObject) {
    //跨域检查，因为跨域才会是 0，https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API
    const {requestStart, responseStart, connectStart} = timingObject
    if (requestStart === 0 && responseStart === 0 && connectStart === 0) {
        return false
    }

    const metrics = parseTimingObjectToNetwork(timingObject)
    const { pathname, protocol } = urlParse(timingObject.name)

    transport({
        endPoints: [FIREBASE_ENDPOINT_NAME, PROMETHEUS_ENDPOINT_NAME],
        type: 'network_api',
        traceName: `network_api_${resolveBizName(timingObject.name)}`,
        url: getUrl(),
        message: {
            metrics: {
                duration: metrics.total_wait,
                ..._.pickBy({
                    ..._.omit(metrics, 'total_wait'),
                    transfer_size: safeComputeInteger(() => timingObject && (timingObject.transferSize / 1024))
                }, _.isFinite)
            },
            attributes: {
                pathname,
                no_response_data: timingObject.encodedBodySize === 0 || is304(timingObject) ? 'true' : 'false',
                protocol: (timingObject && timingObject.nextHopProtocol) || '',
                is_https: protocol === 'https:' ? ' true' : 'false',
                no_download: metrics.download === 0 ? 'true' : 'false',
                api_type: resolveBizName(timingObject.name),
            },
        },
    });
}

// API定义  https://developer.mozilla.org/zh-CN/docs/Web/API/PerformanceTiming
// 基本原理  https://blog.51cto.com/shuizhongyue/1718327
// 各字段完整描述见  https://www.cnblogs.com/btgyoyo/p/6341077.html
function parseTimingObjectToNetwork(timingObject) {
    const metrics = {}
    // 总等待时长
    metrics.total_wait = safeComputeInteger(() => timingObject.duration)
    // 等待重定向时间。未重定向时为0
    metrics.redirect = safeComputeInteger(() => timingObject.redirectEnd - timingObject.redirectStart)
    // DNS查询。本地复用缓存时为0
    metrics.dns = safeComputeInteger(() => timingObject.domainLookupEnd - timingObject.domainLookupStart)
    // TCP连接和SSL连接
    if (timingObject.secureConnectionStart === 0) {
        metrics.tcp = safeComputeInteger(() => timingObject.connectEnd - timingObject.connectStart)
        metrics.tls = 0
    } else {
        metrics.tcp = safeComputeInteger(() => timingObject.secureConnectionStart - timingObject.connectStart)
        metrics.tls = safeComputeInteger(() => timingObject.connectEnd - timingObject.secureConnectionStart)
    }
    // TTFB
    metrics.ttfb = safeComputeInteger(() => timingObject.responseStart - timingObject.requestStart)
    // 响应时间，TTFB至内容下载完成
    metrics.download = safeComputeInteger(() => timingObject.responseEnd - timingObject.responseStart)
    // 总网络消耗时间（redirect之后，至请求结束），不含 redirect/dom 处理时间
    metrics.pure_network = safeComputeInteger(() => timingObject.responseEnd - timingObject.fetchStart)
    metrics.transfer_size = safeComputeInteger(() => timingObject.transferSize)
    // 返回
    return metrics
}

//计算biz
function resolveBizName(path) {
    let result = 'biz'

    if (/\/risk\/user\/action_report/.test(path)) {
        result = 'data'
    } else if (/\/risk/.test(path)) (
        result = 'risk'
    )
    return result
}

function getPerformanceNavigationList() {
    const resources = performance.getEntriesByType('resource')
    const apiEntry = tryCall(() => resources.slice(markPerformanceNavigationIndex).filter(({initiatorType, name}) => (initiatorType === "xmlhttprequest" || initiatorType === "fetch") && (runtime.get('whiteApiDomain').findIndex(domain => name.indexOf(domain) > -1) > -1))) || []
    markPerformanceNavigationIndex = resources.length
    return apiEntry
}
